module.exports = __webpack_public_path__ + "img/DBD-Verified_silver.7c088d21.png";